import React, { useState } from "react";
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

const InputMaskWeight = React.forwardRef(function InputMaskWeight(props, ref) {
  const { inputRef, onChange, onFocus, onBlur, ...inputMaskProps } = props;
  const [focused, setFocused] = useState(false);
  const [hasValue, setHasValue] = useState(false);

  return (
    <IMaskInput
      {...inputMaskProps}
      inputRef={ref || inputRef}
      mask="000 {lbs}"
      definitions={{
        '0': /[0-9]/,
      }}
      lazy={!focused && !hasValue}
      placeholderChar=" "
      onAccept={(value) => {
        const digits = value.replace(/[^0-9]/g, '');
        const nextHasValue = digits.length > 0;
        // Avoid a mask-level re-render when the value/non-value state has not changed.
        setHasValue((previousHasValue) => previousHasValue === nextHasValue ? previousHasValue : nextHasValue);

        let updatedValue = value.trim();
        if (!updatedValue || updatedValue === "lbs") {
          updatedValue = "";
        } else if (updatedValue && updatedValue.endsWith("lbs")) {
          updatedValue = updatedValue.replace("lbs", "pounds");
        }
        onChange({
          target: {
            name: props.name,
            value: updatedValue,
          },
        });
      }}
      onFocus={(e) => {
        setFocused(true);
        // Force cursor to the beginning of the field
        const inputEl = e.target;
        if (inputEl) {
          setTimeout(() => {
            // Sets both start and end selection to index 0
            inputEl.setSelectionRange(0, 0);
          }, 0);
        }
        if (onFocus) onFocus(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        if (onBlur) onBlur(e);
      }}
      overwrite
      spellCheck={false}
    />
  );
});

InputMaskWeight.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default InputMaskWeight;
